import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SideDrawer from "../../input/SideDrawer";
import UserSupplierNegotiation from "./UserSupplierNegotiation";
import { Search } from "react-feather";
import LoadingSpinner from "../../LoadingSpinner";
import SearchDropdown from "../../input/SearchDropdown";
import { getOtherRefSearchDropdown } from "../../../api/keyvalue";
import Button from "../../input/Button";
import { getBehalfOf } from "../../../api/systemUserApi";
import { inputFieldProfile } from "../../../const";
import Input from "../../input/Input";
import { useSelector } from "react-redux";
import { searchUserSupplierNegotiation } from "../../../api/userSupplierNegotiationApi";
import { errorMessageToast } from "../../../helper";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../renderer/StyleRenderer";
import Grid from "../../Grid";

const UserSupplierNegotiationSearch = forwardRef(({}, ref) => {
  const user = useSelector((state) => state.user);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isEditMode, setEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [activeAccordion, setActiveAccordion] = useState(true);
  const defaultState = {
    user: user.username,
    userId: "",
    customer: "",
    minAmount: null,
    maxAmount: null,
    minQty: null,
    maxQty: null,
  };
  const [searchRequest, setSearchRequest] = useState(defaultState);
  const [searchResult, setSearchResult] = useState([]);
  const [searchClicked, setSearchClicked] = useState(false);
  const [currentValue, setCurrentValue] = useState(null);
  const [currentSearchRequest, setCurrentSearchRequest] = useState(null);

  const customerRef = useRef(null);
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    openDrawer: () => {
      setIsDrawerOpen(true);
    },
  }));

  const handleReset = () => {
    setSearchRequest(defaultState);
    setCurrentValue(null);
    setSearchClicked(false);
    customerRef.current?.reset();
    setEditMode(false);
    setSearchResult([]);
  };

  const search = async (request) => {
    setIsLoading(true);
    setSearchClicked(true);

    try {
      const data = await searchUserSupplierNegotiation(request);
      setSearchResult(data);
    } catch (e) {
      errorMessageToast(e);
    }
    setIsLoading(false);
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    setCurrentSearchRequest(searchRequest);
    await search(searchRequest);
  };

  const closeDrawer = async () => {
    setIsDrawerOpen(false);
    setEditMode(false);
    if (searchClicked) {
      await search(currentSearchRequest);
    }
  };

  return (
    <>
      <div className="ui styled accordion" style={{ width: "100%" }}>
        <div
          className={`title ${activeAccordion ? "active" : ""}`}
          onClick={() => setActiveAccordion((prev) => !prev)}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <span>Search</span>
              <Search size={14} style={{ marginLeft: "10px" }} />
              <i className="dropdown icon"></i>
            </div>
          </div>
        </div>
        <div className={`content ${activeAccordion ? "active" : ""}`}>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <form className="ui form">
              <h4 className="ui dividing header"></h4>
              <div className="two fields">
                <SearchDropdown
                  key={1}
                  multiGrid={true}
                  multiGridCurrentValue={searchRequest.user}
                  setReset={() => {}}
                  reset={false}
                  api={getBehalfOf}
                  apiDependency={{
                    customer: null,
                    shipper: null,
                  }}
                  clearable={true}
                  onClear={() => {
                    setSearchRequest((prevState) => ({
                      ...prevState,
                      user: user.username,
                      userId: null,
                    }));
                  }}
                  returnFullObject={true}
                  onResultSelect={(data) => {
                    console.log(data);
                    setSearchRequest((prevState) => ({
                      ...prevState,
                      user: data.usrUsername,
                      userId: data.usrId,
                    }));
                  }}
                  label="User"
                />
                <SearchDropdown
                  ref={customerRef}
                  key={1}
                  clearable={true}
                  setReset={() => {}}
                  reset={false}
                  onClear={() => {
                    setSearchRequest((prevState) => ({
                      ...prevState,
                      customer: null,
                    }));
                  }}
                  onResultSelect={(data) => {
                    setSearchRequest((prevState) => ({
                      ...prevState,
                      customer: data,
                    }));
                  }}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "customer",
                  }}
                  label="Customer"
                />
              </div>
              <div className="four fields">
                <Input
                  label="Min Amount"
                  placeholder="Min Amount"
                  profile={inputFieldProfile.DECIMAL}
                  value={searchRequest.minAmount}
                  onChange={(e) => {
                    setSearchRequest((prevState) => ({
                      ...prevState,
                      minAmount: e.target.value,
                    }));
                  }}
                />
                <Input
                  label="Max Amount"
                  placeholder="Max Amount"
                  profile={inputFieldProfile.DECIMAL}
                  value={searchRequest.maxAmount}
                  onChange={(e) => {
                    setSearchRequest((prevState) => ({
                      ...prevState,
                      maxAmount: e.target.value,
                    }));
                  }}
                />
                <Input
                  label="Min Qty"
                  placeholder="Min Qty"
                  profile={inputFieldProfile.DECIMAL}
                  value={searchRequest.minQty}
                  onChange={(e) => {
                    setSearchRequest((prevState) => ({
                      ...prevState,
                      minQty: e.target.value,
                    }));
                  }}
                />
                <Input
                  label="Max Qty"
                  placeholder="Max Qty"
                  profile={inputFieldProfile.DECIMAL}
                  value={searchRequest.maxQty}
                  onChange={(e) => {
                    setSearchRequest((prevState) => ({
                      ...prevState,
                      maxQty: e.target.value,
                    }));
                  }}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div className="field" style={{ width: "100%" }}>
                  <Button
                    template="search"
                    onClick={(e) => {
                      handleSearch(e);
                    }}
                  />
                  <Button
                    template="searchReset"
                    onClick={(e) => {
                      handleReset(e);
                    }}
                  />
                </div>
              </div>
              {searchClicked && (
                <Grid
                  isLoading={isLoading}
                  content={searchResult}
                  config={[
                    { headerName: "Code", field: "usnCode" },
                    {
                      headerName: "User",
                      field: "usnUser",
                    },
                    {
                      headerName: "Customers",
                      field: "usnCustomerName",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Min Amount",
                      field: "usnMinAmount",
                    },
                    {
                      headerName: "Max Amount",
                      field: "usnMaxAmount",
                    },
                    {
                      headerName: "Min Qty",
                      field: "usnMinQty",
                    },
                    {
                      headerName: "Max Qty",
                      field: "usnMaxQty",
                    },
                    {
                      headerName: "Status",
                      field: "usnStatusValue",
                      cellRenderer: StatusCellStyle,
                    },
                    {
                      headerName: "Active",
                      field: "usnActiveValue",
                      cellRenderer: ActiveCellStyle,
                    },
                  ]}
                  onCellDoubleClicked={async (props) => {
                    setEditMode(true);
                    setCurrentValue(props.data);
                    setIsDrawerOpen(true);
                  }}
                />
              )}
            </form>
          )}
        </div>
      </div>
      <SideDrawer
        open={isDrawerOpen}
        handleDrawerClose={async () => {
          formRef.current?.reset();
          await closeDrawer();
        }}
        head={
          isEditMode && (
            <div
              className="stakeholder-code-header"
              style={{ padding: "10px 16px", borderBottom: "1px solid #ccc" }}
            >
              <h3>User Stakeholder Name:</h3>
            </div>
          )
        }
        body={
          <div className="drawer-content">
            <UserSupplierNegotiation
              ref={formRef}
              currentValues={currentValue}
              editMode={isEditMode}
              closeDrawer={closeDrawer}
            />
          </div>
        }
      />
    </>
  );
});

export default UserSupplierNegotiationSearch;
